import React, { createContext, ReactNode, useState } from "react";

import { Enum_Action_Type, Enum_Geometry_Types } from "src/types";

const FormContext = createContext<{
    openForm: boolean;
    type: Enum_Geometry_Types | null;
    updateType: (type: Enum_Geometry_Types | null) => void;
    handleForm: (value: boolean) => void;
    actionType: Enum_Action_Type;
    updateActionType: (type: Enum_Action_Type) => void;
}>({
    openForm: false,
    type: null,
    actionType: Enum_Action_Type.create,
    updateType: () => {},
    handleForm: () => {},
    updateActionType: () => {},
});

type FormContextProviderProps = {
    children: ReactNode;
};

const FormContextProvider = ({ children }: FormContextProviderProps) => {
    const [type, setType] = useState<Enum_Geometry_Types | null>(null);
    const [openForm, setOpenForm] = useState(false);
    const [actionType, setActionType] = useState(Enum_Action_Type.create);

    const updateType = (value: Enum_Geometry_Types | null) => {
        setType(value);
    };

    const handleForm = (value: boolean) => {
        setOpenForm(value);
    };

    const updateActionType = (value: Enum_Action_Type) => {
        setActionType(value);
    };

    return (
        <FormContext.Provider
            value={{
                type,
                updateType,
                openForm,
                handleForm,
                actionType,
                updateActionType,
            }}
        >
            {children}
        </FormContext.Provider>
    );
};

export { FormContext, FormContextProvider };
